import type { OrderInvoicesData } from '../../model/invoice/interfaces'

import { useAdminRoutes } from '@shared/lib/routes'
import { runApiGet } from '@shared/api'

import { useOrderInvoiceStore } from '../../model/invoice/store'

/** `GET /admin-api/orders/{order}/invoices` — the prefilled fields and the saved files, newest first. */
export const useOrderInvoicesApi = async (orderId: string | number): Promise<OrderInvoicesData | null> => {
  const store = useOrderInvoiceStore()

  return runApiGet<OrderInvoicesData>(useAdminRoutes('admin.order.invoices', { order_id: orderId }), {
    setLoading: store.setLoading,
    handle: (response): OrderInvoicesData => response.data,
  })
}
